import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/shared/query';

/** Refetch lead lists and detail caches after a local mutation or `lead.changed`. */
export function invalidateLeads(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: queryKeys.lead.all }).then(() => undefined);
}
